import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../services/AuthContext";
const ProtectedRoute = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

    if (loading) {
        return null;
    }

  // DON'T ADD ANYTHING HERE
  // This makes it so login and home appear without authentication.
  // If you have problems with your pages redirecting to login then lmk
  if (
    location.pathname === "/login" ||
    location.pathname === "/home"
  ) {
    return <Outlet />;
  }

  // Redirect unauthenticated users
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
